// extracted by mini-css-extract-plugin
export var locationCard = "_id-0";